<header
  class="py-16 relative z-10 w-full bg-primary-100 bg-cover bg-[url('/assets/img/theme-bg.webp')]"
>
  <div class="max-w-screen-xl mx-auto px-4">
    <div class="flex items-center justify-center flex-col text-center">
      <div class="w-full">
        <h1 class="font-bold text-white text-4xl mb-4">
          {{ header() }}
        </h1>
        <nav>
          <ol
            class="flex justify-center gap-2 m-0 text-white [&>a:not(:last-child)]:after:content-['/'] [&>a:not(:last-child)]:after:ml-1 [&>a:last-child]:text-accent"
          >
            <ng-content></ng-content>
          </ol>
        </nav>
      </div>
    </div>
  </div>
</header>
